<template>
  <v-container id="orders-settings" fluid>
    <v-card outlined>
      <validation-observer ref="form">
        <v-container id="location-details" fluid>
          <v-card outlined>
            <v-container fluid v-if="loadedSettings">
              <v-row>
                <v-col cols="12" >
                  <v-switch
                    v-model="loadedSettings.errorEmailActivated"
                    :label="$t('triggersSettings.activateErrorEmails')"
                    :messages="$t('triggersSettings.activateErrorEmailsMessage')"
                  />
                </v-col>
                <v-col cols="12" v-if="loadedSettings.errorEmailActivated">
                  <validation-provider class="width-100" rules="required" name="condition field" v-slot="{ errors }">
                    <v-combobox
                      v-model="loadedSettings.errorEmailList"
                      dense
                      :label="$t('triggersSettings.emailsAddresses')"
                      hide-details="auto"
                      multiple
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-container>
      </validation-observer>
      <v-container fluid>
        <v-row justify="center">
          <v-btn
            class="ma-2 text-uppercase"
            color="primary"
            outlined
            :loading="loading"
            @click="validate"
          ><span v-if="areNewSettings">{{$t("settings.save")}}</span><span v-else>{{$t("settings.update")}}</span></v-btn>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>

  import { EventBus } from '../../event-bus'
  import { ValidationProvider, ValidationObserver, extend} from 'vee-validate'
  import { required} from 'vee-validate/dist/rules'

  extend('required', {
    ...required,
    message: 'This field is required'
  });

  export default {
    name: "TriggersSettings",
    components: {
      ValidationObserver: ValidationObserver,
      ValidationProvider:ValidationProvider
    },
    data() {
      return {
        areNewSettings: true,
        loading: false,
        loadedSettings: {
          errorEmailActivated: false,
          errorEmailList: []
        }
      }
    },
    mounted() {
      this.listTriggersSettings()
    },
    methods: {
      listTriggersSettings(){
        this.loading = true
        let myInit = {
          headers: {
            "Authorization": 'Bearer ' + this.$auth.accessToken
          }
        }
        this.$Amplify.API.get("triggers", "/v1/int/triggers-settings", myInit)
          .then((res) => {
            console.log(res.settings, typeof res)
            if(res.nbTriggersSettings > 0) {
              this.loadedSettings.errorEmailActivated = res.settings[0].error_email_activated
              this.loadedSettings.errorEmailList = res.settings[0].error_email_list
              this.loadedSettings.id = res.settings[0]._id
              this.areNewSettings = false
            }
            this.loading = false
          })
          .catch((e) => {
            console.log(e)
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: e.message,
              color: "error"
            })
            this.loading = false
          })
      },
      async validate() {
        if(await this.$refs.form.validate()){
          let body = {
            error_email_activated: this.loadedSettings.errorEmailActivated,
            error_email_list: this.loadedSettings.errorEmailList
          }
          let myInit = {
            headers: {
              "Authorization": 'Bearer ' + this.$auth.accessToken
            },
            body: body
          }
          if(this.areNewSettings){
            this.createSettings(myInit)
          }else{
            this.updateSettings(myInit)
          }
        }
        else {
          EventBus.$emit('displaySnackbar', {
            display: true,
            text: this.$t("settings.invalidSettings"),
            color: "error"
          })
        }
      },
      createSettings(myInit){
        this.loading = true
        this.$Amplify.API.post("triggers", "/v1/int/triggers-settings", myInit)
          .then((res) => {
            console.log(res)
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t("settings.settingsCreated"),
              color: "success"
            })
            this.loadedSettings.id = res._id
            this.areNewSettings = false
            this.loading = false
          })
          .catch((e) => {
            console.log(e)
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: e.message,
              color: "error"
            })
            this.loading = false
          })
      },
      updateSettings(myInit){ // update settings with new values
        this.loading = true
        this.$Amplify.API.put("triggers", "/v1/int/triggers-settings/"+ this.loadedSettings.id, myInit)
          .then(() => {
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t("settings.settingsUpdated"),
              color: "success"
            })
            this.loading = false
          })
          .catch((e) => {
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: e.message,
              color: "error"
            })
            this.loading = false
          })
      }
    },
  }
</script>
